import PropTypes from 'prop-types'
import React from 'react'

import { EntrySectionSkeleton } from '../Skeleton'

import { SectionContainer, HeaderRow, SectionTitle, ValueContainer, Value, Badge, DueDate, ChangeLink } from './styles'

export const EntrySection = ({ isLoading, entryOptions, formattedValue, formattedDueDate, badge, onChangeEntry }) => {
  if (isLoading) {
    return <EntrySectionSkeleton />
  }

  return (
    <SectionContainer>
      <HeaderRow>
        <SectionTitle>Entrada</SectionTitle>
        {entryOptions && entryOptions.length > 1 && <ChangeLink onClick={onChangeEntry}>Escolher outro valor</ChangeLink>}
      </HeaderRow>
      <ValueContainer>
        <Value>{formattedValue || '-'}</Value>
        {badge && (
          <Badge>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_6810_8627)">
                <path
                  d="M5.99996 0.25L8.11296 3.3415L11.7065 4.396L9.41896 7.361L9.52646 11.104L5.99996 9.845L2.47346 11.104L2.58096 7.361L0.293457 4.396L3.88696 3.3415L5.99996 0.25ZM4.99996 6H3.99996C3.99995 6.52178 4.20385 7.0229 4.56816 7.39644C4.93247 7.76998 5.42833 7.98636 5.94994 7.99941C6.47156 8.01245 6.97762 7.82114 7.36014 7.46628C7.74267 7.11142 7.97138 6.62112 7.99746 6.1L7.99996 6H6.99996C7.00112 6.25949 6.90136 6.50927 6.72177 6.69658C6.54217 6.88388 6.2968 6.99403 6.03749 7.00377C5.77818 7.01351 5.52523 6.92206 5.3321 6.74875C5.13896 6.57545 5.02076 6.33385 5.00246 6.075L4.99996 6Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_6810_8627">
                  <rect width="12" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {badge}
          </Badge>
        )}
      </ValueContainer>
      <DueDate>Vencimento dia {formattedDueDate || '-'}</DueDate>
    </SectionContainer>
  )
}

EntrySection.propTypes = {
  isLoading: PropTypes.bool,
  entryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.number,
      dueDate: PropTypes.string,
      isRecommended: PropTypes.bool,
      badge: PropTypes.string
    })
  ),
  formattedValue: PropTypes.string,
  formattedDueDate: PropTypes.string,
  badge: PropTypes.string,
  onChangeEntry: PropTypes.func
}

EntrySection.defaultProps = {
  isLoading: false,
  entryOptions: [],
  formattedValue: '',
  formattedDueDate: '',
  badge: '',
  onChangeEntry: () => {}
}
